module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-3-img-pc_60611b0c5e285e62ecd474066f3995ac.png";